/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free hash generator. Create SHA-1, SHA-256, SHA-384 and SHA-512 hashes from any text, right in your browser. No signup.`)
};

const es_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de hash gratis. Crea SHA-1, SHA-256, SHA-384 y SHA-512 a partir de cualquier texto, directamente en tu navegador. Sin registro.`)
};

const de_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Hash-Generator. Erstellen Sie SHA-1-, SHA-256-, SHA-384- und SHA-512-Hashes aus beliebigem Text direkt in Ihrem Browser. Keine Anmeldung erforderlich.`)
};

const nl_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis hash-generator. Maak SHA-1, SHA-256, SHA-384 en SHA-512 hashes van elke tekst, rechtstreeks in uw browser. Geen registratie nodig.`)
};

const fr_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de hash gratuit. Créez des hash SHA-1, SHA-256, SHA-384 et SHA-512 à partir de n'importe quel texte, directement dans votre navigateur. Pas d'inscription.`)
};

const it_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di hash gratuito. Crea hash SHA-1, SHA-256, SHA-384 e SHA-512 da qualsiasi testo, direttamente nel tuo browser. Nessuna registrazione.`)
};

const pt_br2_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de hash gratuito. Crie hashes SHA-1, SHA-256, SHA-384 e SHA-512 a partir de qualquer texto, diretamente no seu navegador. Sem cadastro.`)
};

const pt_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de hash gratuito. Crie hashes SHA-1, SHA-256, SHA-384 e SHA-512 de qualquer texto, diretamente no seu navegador. Sem registo.`)
};

const ja_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のハッシュジェネレーター。任意のテキストからSHA-1、SHA-256、SHA-384、SHA-512ハッシュをブラウザで直接作成します。サインアップ不要。`)
};

const zh_hg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费哈希生成器。直接在浏览器中为任意文本创建 SHA-1、SHA-256、SHA-384 和 SHA-512 哈希值，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_tool_description", locale)
	if (locale === "en") return en_hg_tool_description(inputs)
	if (locale === "es") return es_hg_tool_description(inputs)
	if (locale === "de") return de_hg_tool_description(inputs)
	if (locale === "nl") return nl_hg_tool_description(inputs)
	if (locale === "fr") return fr_hg_tool_description(inputs)
	if (locale === "it") return it_hg_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_hg_tool_description(inputs)
	if (locale === "pt") return pt_hg_tool_description(inputs)
	if (locale === "ja") return ja_hg_tool_description(inputs)
	return zh_hg_tool_description(inputs)
};